"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MID = void 0;
exports.MID = {
    alias: 'EXT_TEXTO',
    description: 'retorna a substring da expressão',
    arg_names: ['base', 'início', 'comprimento'],
    args_description: ['uma expressão de texto', 'o índice de início', 'o comprimento da substring'],
};
